import { IsInt, IsNotEmpty } from 'class-validator';

export class RegisterSurfboardOnlineTerminalDto {
  @IsNotEmpty()
  @IsInt()
  merchantId: number;

  @IsNotEmpty()
  @IsInt()
  posDeviceId: number;
}